/**
 * Controller: GroupsCreateModal
 */
angular.module('acme.view.application.groups.createModal.controllers', [])
.controller('GroupsCreateModalController', [ '$scope', '$uibModalInstance', 'groups', function ($scope, $uibModalInstance, groups) {

    $scope.errors = [];

    $scope.model = {
      id: '',
      name: '',
      displayName: ''
    };

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.trim = function(s) {
      return s.replace(/\s+/g, '').toLowerCase();
    };

    $scope.isUnique = function() {
      var i, ii,
        trimmed,
        trimmedCurrent = $scope.trim($scope.model.name),
        r = true;

      for (i=0,ii=groups.length;i<ii;i++) {
        trimmed = $scope.trim(groups[i].name);
        if (trimmedCurrent === trimmed) {
          r = false;
          break;
        }
      }

      return r;

    };

    $scope.done = function() {
      if ($scope.isUnique()) {
        if ($scope.model.name.replace(/\s+/g, '').length > 0) {
          $scope.success();
        }else{
          $scope.errors.push({ message: 'Please enter a valid role name'});
        }
      }else{
        $scope.errors.push({ message: 'A role with name "' + $scope.model.name + '" already exists' });
      }
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close($scope.model);
    };

    $scope.init();

}]);